import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AFFILIATE_DEEPLINK_KEY = 'pending_affiliate_deeplink';

/**
 * /affiliate/dashboard?event_id=...&prompt=generate
 *
 * Aliases to the existing /dashboard/referrals route, preserving query params.
 * If the visitor is not logged in, store the deep-link and send them to register;
 * AuthContext (or post-login handler) reads this key to redirect them back here.
 */
export default function AffiliateDashboardRedirect() {
  const [params] = useSearchParams();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      // Stash the full deep-link so the post-login flow can resume it.
      const dest = `/dashboard/referrals?${params.toString()}`;
      try { localStorage.setItem(AFFILIATE_DEEPLINK_KEY, dest); } catch { /* ignore */ }
    }
  }, [loading, user, params]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  }

  const qs = params.toString();

  if (!user) {
    // Send them to register; they can also log in from there.
    const redirectParam = encodeURIComponent(`/dashboard/referrals${qs ? `?${qs}` : ''}`);
    return <Navigate to={`/register?next=${redirectParam}`} replace />;
  }

  // Authenticated → forward to the real dashboard with the same params
  return <Navigate to={`/dashboard/referrals${qs ? `?${qs}` : ''}`} replace />;
}
